import { RouteConfig } from 'vue-router';

export class BookingLinkRoute {
  static BOOKING_LINK: RouteConfig = {
    name: 'booking-link',
    path: '/booking-link'
  };
}
